import React, { useContext, ReactNode } from 'react';
import { Event } from 'graphql/fragments/types/Event';
import { Event as QueryEvent, EventVariables } from 'graphql/queries/types/Event';
import { getEvent } from 'graphql/queries';
import { useQuery } from '@apollo/client';
import { Navigate } from 'react-router-dom';

interface EventContextType extends Event {}

const EventContext = React.createContext<EventContextType | null | undefined>(null);

export function useEventContext() {
    const context = useContext(EventContext);
    if (!context) {
        return undefined;
    }
    return context!;
}

export function EventProvider({ eventAlias, children }: { eventAlias: string; children?: ReactNode | undefined }) {
    const {
        loading,
        data: eventData
        // error,
        // refetch
    } = useQuery<QueryEvent, EventVariables>(getEvent, {
        variables: { eventAlias }
    });

    if(!loading && eventData?.quiz_master_events.length !== 1) {
        return <Navigate to="/" replace />;
    }
    const event = eventData?.quiz_master_events.at(0);

    return <EventContext.Provider value={event}>{!loading && children}</EventContext.Provider>;
}
